/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - lapa nav atrasta",
  "ComingSoon": "Drīzumā",
  "YesanPersonalFinance": "Yesan, Personīgās finanses",
  "Yesan": "Yesan",
  "PersonalFinance": "Personīgās finanses",
  "YesanDownload": "Yesan Lejupielādēt",
  "ThisWebsiteUsesCookies": "Mēs izmantojam sīkfailus, lai apkopotu un analizētu informāciju par mūsu vietnes veiktspēju un izmantošanu, kā arī lai nodrošinātu sociālo mediju funkcijas. Turpinot, jūs piekrītat mūsu",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Kļūsti finansiāli brīvs",
  "inStepsAndActions": "8 soļos un 3 darbībās.",
  "TrackPlanAnalyze": "Izsekot. Plānojiet. Analizē.",
  "FTrack": "1. Izsekojiet",
  "FPlan": "2. Plāns",
  "FAnalyze": "3. Analizēt",
  "Features": "Funkcijas",
  "FeaturesSubHeading": "Tīrs iesācējs, kas jau ir finansiāli zinošs, šī ir lietotne, kas jums nepieciešama, lai kļūtu finansiāli brīvs.",
  "ManageAccounts": "Pārvaldīt kontus",
  "CashLiquidFixedAssetsLiabilities": "Naudas, likvīdo līdzekļu, pamatlīdzekļu un saistību konti.",
  "TrackTransactions": "Sekojiet darījumiem",
  "IncomesExpensesTransferInvestments": "Ieņēmumi, izdevumi, pārskaitījumi, ieguldījumi.",
  "ImportExport": "Importēt / eksportēt",
  "YourDataAlwaysAccessible": "Jūsu dati vienmēr pieejami.",
  "PlanYourFreedom": "Plānojiet savu brīvību",
  "StepsAwayFromFI": "8 soļi līdz finansiālai neatkarībai.",
  "BudgetsAndGoals": "Budžets un mērķi",
  "CheckYourProgressAndAchieve": "Pārbaudiet savu progresu un sasniedziet savus finanšu mērķus.",
  "DashboardAndAnalytics": "Kontrolpanelis un analītika",
  "ReviewLearnOptimizeWith": "Pārskatiet, mācieties, optimizējiet, izmantojot diagrammas, ieskatus un rīkus.",
  "Security": "Drošība",
  "MilitaryGradeEncryption": "Militārās klases šifrēšana, biometrijas atbalsts, dati tiek glabāti jūsu ierīcēs.",
  "OfflineMode": "Bezsaistes režīms",
  "YourDataAlwaysAccessibleAndModif": "Jūsu dati vienmēr pieejami un modificējami.",
  "Track": "Izsekojiet",
  "Income": "Ienākumi",
  "Expense": "Izdevumi",
  "Transfer": "Pārsūtiet",
  "transactionsAndManageAccounts": "darījumus un pārvaldiet dažādus kontus:",
  "checkings": "Pārbaudes",
  "savings": "Uzkrājumi",
  "realEstate": "Nekustamais īpašums",
  "stocks": "Akciju tirgi",
  "bonds": "Obligācijas",
  "crypto": "Kriptovalūtas",
  "notes": "Naudaszīmes, skaidras naudas maki",
  "envelopes": "Aploksnes",
  "privateEquity": "Privātais kapitāls",
  "metal": "Metāls",
  "retirement": "Pensionēšanās",
  "lifeInsurance": "Dzīvības apdrošināšana",
  "intellectualProperty": "Intelektuālais īpašums",
  "otherLiquidAsset": "Citi likvīdi aktīvi",
  "otherFixedAsset": "Citi pamatlīdzekļi",
  "mortgage": "Hipotēka",
  "loan": "Patēriņa kredīts",
  "creditCard": "Kredītkarte",
  "otherLiability": "Citas saistības",
  "AccountsManagement": "Kontu pārvaldība",
  "MultipleAccountsTypesAndGrouping": "Vairāki kontu veidi un grupēšana",
  "LinkAccounts": "Savu iestāžu kontu sasaiste (pieejama tikai dažās valstīs)",
  "SmartAccounts": "Viedie konti",
  "AddEditDeleteTransactions": "Darījumu pievienošana / rediģēšana / dzēšana",
  "TickVerifiedTransactions": "Atzīmējiet pārbaudītus darījumus",
  "CategorizeTransactions": "Darījumu kategorizēšana",
  "TagTransactions": "Atzīmējiet darījumus",
  "TrackKakeiboType": "Izsekot Kakeibo veidu",
  "TrackInvestments": "Izsekot ieguldījumus (pieejams tikai dažās valstīs)",
  "ImportFromCSVFile": "Importēt visus vai pakāpeniski visus darījumus no CSV faila",
  "ExportToCSVFile": "Eksportēt darījumus uz CSV failu",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 soļi ceļā uz finansiālās neatkarības plānu, detalizēta budžeta plānošana, ātrāk sasniedziet savus finanšu mērķus.",
  "levelsTowardsFI": "8 līmeņi ceļā uz finansiālo neatkarību",
  "EstablishBudgetsPer": "Budžeta izveide uz",
  "account": "kontu",
  "accountType": "konta veids",
  "KakeiboType": "Kakeibo tips",
  "category": "kategorija",
  "tag": "birka",
  "label": "etiķete",
  "TrackBudgetsPerFrequency": "Izsekot budžetus pēc biežuma",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Izveidojiet mērķus attiecībā uz izdevumiem, bilanci, naudas plūsmu, darbībām",
  "TrackGoalsProgress": "Sekojiet mērķu progresam",
  "ReviewLearnOptimizeWithReportsCharts": "Pārskatiet, mācieties, optimizējiet, izmantojot pārskatus, diagrammas, tendences, ieskatus, rīkus.",
  "Dashboard": "Vadības panelis",
  "FSNetWorth": "Finanšu pārskati: Tīrā vērtība",
  "FSPnL": "Finanšu pārskati: Peļņas un zaudējumu aprēķins: Peļņas un zaudējumu aprēķins",
  "FSBalanceSheetAssetsLiabilities": "Finanšu pārskati: Bilance, aktīvi, pasīvi",
  "FSCashFlow": "Finanšu pārskati: Naudas plūsmas pārskats, debeta kredīts, plūsmas",
  "FSFlows": "Finanšu pārskati: Plūsmas",
  "FSRatios": "Finanšu pārskati: Ratios",
  "TrendsMonthEnd": "Mēneša beigu tendences: Ieņēmumi un izdevumi, naudas plūsma",
  "TrendsPerformance": "Darbības rezultātu tendences: Gada dati, Mēneša dati, Mēneša dati, WW",
  "IncomeTrendsPer": "Ienākumu tendences uz",
  "SpendingTrendsPer": "Izdevumu tendences uz",
  "RecurringItemsIE": "Atkārtotie posteņi: Ieņēmumi un izdevumi",
  "DebtProgressTrends": "Parāda progresa tendences",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD pārskats, pēdējais mēnesis, tendences",
  "FIWCLE": "Finanšu neatkarība: Sienas diagramma, izdevumi pēc dzīves enerģijas",
  "DebtPaydownSnowballAvalanche": "Parādu atmaksa: Sniega bumba, lavīna",
  "FullyCustomizableAnalyticsRange": "Pilnībā pielāgojams analītikas laika diapazons",
  "ContactUs": "Sazinieties ar mums",
  "Privacy": "Konfidencialitāte",
  "Terms": "Noteikumi",
  "About": "Par",
  "IAgreeToThe": "Es piekrītu",
  "AndThe": "un",
  "PrivacyPolicy": "Konfidencialitātes politika",
  "TermsOfUse": "Lietošanas noteikumi",

  "DigitalSoftwareExperienceTagline": "Digitālās programmatūras pieredze mūsdienu pasaulē",
  "DigitalExperience": "Digitālā pieredze",
  "SoftwareForTheModernWorld": "Programmatūra mūsdienu pasaulei",
  "MobileApplications": "Mobilās lietojumprogrammas",
  "forConnectedAndOfflineHumans": "savienotiem un bezsaistes cilvēkiem",
  "CloudSaaS": "Mākoņa SaaS",
  "ResponsiveAndWebServices": "Responsīvie un tīmekļa pakalpojumi",
  "PersonalFinanceServices": "Personīgo finanšu pakalpojumi",
  "YS_p1": "Yesan ir dinamisks programmatūras uzņēmums, kas specializējas modernu mobilo lietotņu izstrādē, kas pielāgotas patērētājiem. Labi izprotot mūsdienu tehnoloģiski zinošo lietotāju mainīgās vajadzības un vēlmes, Yesan cenšas radīt intuitīvu, saistošu un funkcionāli bagātu mobilo pieredzi, kas bagātina lietotāju dzīvi.",
  "YS_p2": "Yesan misijas pamatā ir nemitīga apņemšanās nodrošināt inovācijas un radošumu, un katrs produkts tiek rūpīgi izstrādāts, lai nodrošinātu nevainojamu funkcionalitāti un izcilu lietotāja pieredzi.",
  "PersonalFinanceApplication": "Personīgo finanšu lietojumprogramma",
  "YPF_p1": "Yesan, Personal Finance ir mūsdienīga personīgo finanšu mobilā lietojumprogramma, kas izstrādāta, lai sniegtu lietotājiem visaptverošus finanšu pārvaldības rīkus, kas ērti pieejami uz rokas. Ar elegantu un intuitīvu saskarni Yesan, Personal Finance piedāvā holistisku pieeju finanšu pārvaldībai, kas piemērota visu līmeņu finanšu pratības lietotājiem.",
  "YPF_p2": "Galvenās funkcijas ietver budžeta izsekošanu, izdevumu kategorizēšanu un darījumu uzraudzību reāllaikā, ļaujot lietotājiem bez piepūles gūt ieskatu savos tēriņu paradumos. Lietotne piedāvā arī pielāgojamas budžeta veidošanas iespējas, ļaujot lietotājiem noteikt finanšu mērķus un sekot līdzi to sasniegumiem laika gaitā.",
  "YPF_p3": "Turklāt Yesan, Personal Finance par prioritāti izvirza drošību, izmantojot modernākos šifrēšanas protokolus, lai aizsargātu lietotāju sensitīvo finanšu informāciju. Izmantojot bankas līmeņa drošības pasākumus, lietotāji var droši savienot savus kontus un sinhronizēt darījumus, neapdraudot privātumu.",
  "YPF_p4": "Yesan, Personal Finance ir plašāks par vienkāršu budžeta plānošanu, piedāvājot padziļinātu analīzi un personalizētus ieteikumus, lai optimizētu finanšu lēmumus. Neatkarīgi no tā, vai runa ir par potenciālo uzkrājumu iespēju identificēšanu, ieguldījumu portfeļu uzraudzību vai parādu atmaksas stratēģiju pārvaldību, lietotne sniedz pielāgotus ieskatus, lai palīdzētu lietotājiem sasniegt viņu finanšu mērķus.",
  "Discover": "Atklājiet",
  "Firstname": "Vārds",
  "Lastname": "Uzvārds",
  "Company":"Uzņēmums",
  "Subject": "Temats",
  "Email": "E-pasts",
  "Message": "Ziņa",
  "ThankYouForContactingUs": "Paldies, ka sazinājāties ar mums",
  "ValidFirstnameRequired": "Nepieciešams derīgs vārds.",
  "ValidLastnameRequired": "Nepieciešams derīgs uzvārds.",
  "ValidEmailAddressRequired": "Lūdzu, ievadiet derīgu e-pasta adresi.",
  "ValidSubjectRequired": "Lūdzu, izvēlieties derīgu tematu.",
  "ValidMessageRequired": "Lūdzu, ievadiet derīgu ziņojumu.",
  "UnableToSendTheFormPleaseRetryLater": "Nav iespējams nosūtīt veidlapu, lūdzu, mēģiniet vēlreiz vēlāk.",
  "Information": "Informācija",
  "Sales":"Pārdošana",
  "Support": "Atbalsts",
  "Press": "Spiediet",
  "Partnership": "Partnerība",
  "Other": "Citi",
  "Blog":"Blogs",

  "Accept":"Pieņemt",
  "Decline":"Noraidīt",

  "WorklogCalendar":"Jira darba žurnāla kalendārs",

  "DirectlyAccessibleInProjectApps":"Tiešā piekļuve projektu lietotnēs",
  "VisualizeWhereYouSpentYourTime":"Vizualizējiet, kur esat pavadījis savu laiku",
  "AllYourWorklogsInACalendar":"Visi jūsu darba žurnāli kalendārā",
  "MonthSummary":"Mēneša kopsavilkums",
  "CheckIfYouForgotToLogTime":"Pārbaudiet, vai neesat aizmirsis reģistrēt laiku.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Tieša piekļuve jautājumiem un laika atjaunināšana",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Noklikšķiniet uz darba žurnāla elementa, lai tieši piekļūtu jautājumiem un rediģētu savu izsekoto laiku.",
  "AlsoAvailableInDarkMode":"Pieejams arī tumšajā režīmā",
  "DirectlyLogWorkOnTheCalendarVisually":"Vizuāli tieši reģistrēt darbu kalendārā",
  "ClickOnTheCalendarToCreateNewWorklog":"Noklikšķiniet uz kalendāra, lai izveidotu jaunu darba žurnālu",

  "AppsForAtlassian":"Atlassian lietotnes",
  "YCL_p1":"Vizualizējiet visus savus darba žurnālus kalendārā ar mēneša, nedēļas, darba nedēļas, dienas skatiem.",
  "YCL_p2":"Reģistrējiet darbu tieši no kalendāra, vizuāli izvēloties laika intervālu.",
  "YCL_p3":"Identificējiet, ja esat aizmirsis izsekot darba laika uzskaiti.",
  "YCL_p4":"Pieejams jūsu valodā: Angļu (Apvienotā Karaliste), angļu (ASV), čehu, dāņu, franču, holandiešu, igauņu, igauņu, islandiešu, itāļu, japāņu, japāņu, korejiešu, ķīniešu (vienkāršotā), ķīniešu (tradicionālā), poļu, portugāļu (Brazīlija), portugāļu (Portugāle), krievu, somu, spāņu, somu, ungāru, vācu, zviedru, turku, vācu.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Finanšu portfelis Jira",
  "BringRealFinancialPortfolio":"Ieviesiet Jira reālu finanšu portfeļa pārvaldību. Vienā vietā uzraugiet budžetus, kapitālieguldījumus (CapEx) un darbības izmaksas (OpEx), kā arī projektu izmaksas.",
  "YFPAboutQ":"Cik patiesībā mums izmaksā mūsu Jira projekti?",
  "YFPAbout":"Finanšu portfelis Jira\nFinanšu vadītāji un PMO cīnās, lai atbildētu uz vienkāršu jautājumu:\nCik patiesībā mums izmaksā mūsu Jira projekti?\nJira uzrauga darbu.\nFinanšu nodaļa uzrauga budžetus.\nŠī lietotne beidzot savieno abus.\n\nFinanšu portfelis pārvērš Jira par vieglu PPM + finanšu plānošanas platformu — bez nepieciešamības pēc dārgiem uzņēmuma rīkiem.",
  "YFPPorfolioQ":"Portfeļu budžeti un uzraudzība",
  "YFPPorfolioP":"Izveidojiet portfeļus, kas aptver vairākus Jira projektus, un definējiet: budžeta summu, valūtu, datu diapazonu, iekļautos projektus, komandas. Automātiski uzraugiet faktiskās izmaksas, kad darbs notiek Jira.",
  "YFPPorfolioListQ":"Portfeļi",
  "YFPPorfolioListP":"Izveidojiet finanšu portfeļus, kas apvieno vairākus Jira projektus, un uzreiz redziet: budžetu salīdzinājumā ar faktiskajām izmaksām, projekta izdevumu tempu reālajā laikā, CapEx un OpEx sadalījumu, izmaksas par katru uzdevumu un projektu, eksportējamos finanšu pārskatus. Viss tiek nodrošināts tieši no Jira darba žurnāliem.",
  "CostQ":"Automātiska izmaksu aprēķināšana",
  "CostP":"Pārvērtiet laika uzskaiti reālos finanšu datos. Lietotne: lasa Jira darba žurnālus, piemēro stundas likmes, ik dienas aprēķina reālās projekta izmaksas. Bez izklājlapām. Bez manuāla darba.",
  "RatesQ":"Tarifi",
  "RatesP":"Iestatiet stundas likmi katram projektam, komandai vai vispārīgi",
  "ReportQ":"CSV finanšu pārskati",
  "ReportP":"Eksportējiet portfeļa finanšu datus dažu sekunžu laikā. Ideāli piemērots: finanšu komandām, finanšu direktora pārskatiem, budžeta plānošanai, revīzijas atbalstam",
  "SettingsQ":"CapEx un OpEx klasifikācija",
  "SettingsP":"Atbalsta grāmatvedības un revīzijas prasības. Klasificējiet darbu: kapitalizējama attīstība (CapEx), operatīvais darbs (OpEx). Izveidojiet eksportējamus pārskatus, kas ir gatavi finanšu komandām."
};

export const documents = {
};
